import React from 'react';
import {useSelector} from 'react-redux';
import {useReducerAsync} from 'use-reducer-async';
import {useParams} from 'react-router-dom';

import ClientDetailsView from './ClientDetailsView';

import getAsyncActionHandlers from './store/asyncActionHandlers';
import reducer from './store/reducer';
import {initialState, interventionsPageSize, usersPageSize} from './store/utils';

const store = React.createContext(initialState);
export const useClientDetailsStore = () => React.useContext(store);

function ClientDetailsStore() {
  const organisation = useSelector(globalState => globalState.organisation);
  const params = {
    clientId: Number(useParams().clientId),
    organisation,
    interventionsPageSize,
    usersPageSize
  };

  const {Provider} = store;

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    getAsyncActionHandlers(params)
  );

  return (
    <Provider value={{state, dispatch}}>
      <ClientDetailsView/>
    </Provider>
  );
}

export default ClientDetailsStore;
